import React from "react";
import { Link } from "react-router-dom";
import logo from "./assets/Xmaths.png";
import CircularText from "./CircularText";

const Footer = () => {
  return (
    <footer className="bg-white/10 backdrop-blur-md border-t border-white/20 text-white/80 pt-12 pb-6">
      <div className="max-w-7xl border-t border-white/20 mt-8 pt-6 mx-auto px-6">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 items-center">
          {/* Brand Info */}
          <div className="space-y-4">
            <div className="flex items-center">
              <div class="scale-50 h-28 -mt-8 -mx-8">
                <div className="bg-[url('/Xmaths.png')] bg-center bg-[length:120px] bg-no-repeat filter brightness-0 invert">
                  <CircularText
                    text="✦ SHEMIES ✦ MATH ✦ IGCSE "
                    onHover="speedUp"
                    spinDuration={20}
                    className=""
                  />
                </div>
              </div>
            </div>
          </div>

          {/* Quick Links */}
          <div className="flex justify-end w-1/2">
            <div className="space-y-4">
              <h3 className="text-lg font-semibold text-white drop-shadow-[0_2px_4px_rgba(0,0,0,0.6)]">
                Quick Links
              </h3>
              <ul className="space-y-2">
                {['Login', 'SignUp'].map((item) => (
                  <li key={item}>
                    <Link
                      to={`/${item.toLowerCase()}`}
                      className="text-white/80 hover:text-teal-300 transition duration-300 hover:pl-2 block drop-shadow-[0_1px_2px_rgba(0,0,0,0.5)]"
                    >
                      {item}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>

        <div className="border-t border-white/20 mt-8 pt-6 flex justify-center">
          <p className="text-white/80 text-sm drop-shadow-[0_1px_2px_rgba(0,0,0,0.5)]">
            © {new Date().getFullYear()} Shemies-Maths. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;